<template>
    <div>
        <div class="app-list-data" >
            <div v-if="Object.keys(documentData).length === 0">
                <label> ご提供を依頼していたすべての書類を受け取りました。</label><br/>
                <label> ありがとうございました。</label>
            </div>
            <div v-else>
              <div id="category-subject" style="margin-top: 2%">
                <ul class="flex">
                  <li>
                    <p>お客様でご用意いただく書類リスト</p>
                    <p>・お客様にご提供をお願いしたい書類を一覧にしております。</p>
                    <p>・ご提供いただいた書類を担当者が確認することで一覧に表示されなくなります。</p>
                    <p>・項目をクリックしていただくことで、該当項目へジャンプすることができます。</p>
                  </li>
                </ul>
              </div>
              <div class="table-responsive table-document-list" >
                <table class="el-table-cus table mb-3 no-border-radius">
                  <thead class="border-bottom-custom">
                  <tr>
                    <th style="min-width: 80px; width:60%">書類名</th>
                    <th style="width:130px">ステータス</th>
                    <th style="min-width: 50px;">連絡事項</th>
                  </tr>
                  </thead>
                  <tbody v-for="(okey, index) in Object.keys(documentData)" :key="index">
                  <template>
                    <tr :id="'category_'+okey">
                      <td colspan="3" class="text-left">
                        <label  v-text="documentData[okey][0].categoryName"></label>
                        <el-button v-if="showHideBtn" class="button-show-hide" icon="el-icon-caret-top" @click="showHideSubject('category_'+okey)"></el-button>
                        <el-button v-else class="button-show-hide" icon="el-icon-caret-bottom" @click="showHideSubject('category_'+okey)"></el-button>
                      </td>
                    </tr>
                  </template>
                  <template v-for="(row, rindex) in documentData[okey]">
                    <tr :key="rindex" :value="index" :name="'category_'+okey"
                        :style="setColor(row.documentStatusForDisplay)"
                        :class="setHoverColorClass(row.documentStatusForDisplay)"
                        :id="row.subjectName + '_link'"
                    >
                      <td class="text-left">
                        <el-link class="subject-name" type="primary" v-text="row.subjectName" @click="scrollSubject(row)"></el-link>
                      </td>
                      <td>
                        <label v-text="row.documentStatusForDisplay"></label>
                      </td>
                      <td>
                        <label class="memo-text" v-text="row.memo"></label>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'DocumentList',
    props: ['documentData'],
    data () {
        return {
            SpDocumentListReq: {
                ankenId: 0
            },
            sizeData: 0,
            showHideBtn: true
        }
    },
    created () {
        let ankenId = parseInt(this.$route.params.id)
        this.SpDocumentListReq.ankenId = ankenId
    },
    methods: {
        showHideSubject: async function (name) {
            const data = document.getElementsByName(name)
            if (data.length > 0) {
                let display = data[0].style.display

                if (display === '') {
                    display = 'none'
                    this.showHideBtn = false
                } else {
                    display = ''
                    this.showHideBtn = true
                }

                for (let i in data) {
                    if (data[i].style !== undefined) data[i].style.display = display
                }
            }
        },
        setColor (status) {
            if (status === 'ご提供待ち' || status === '再提供依頼中') return 'background-color: #FFCCFF !important'
            else return 'background-color: #fffafa;'
        },
        setHoverColorClass (status) {
            if (status === 'ご提供待ち' || status === '再提供依頼中') return ['waiting']
            else return []
        },
        scrollSubject (subject) {
            const subjectElm = document.getElementById(subject.subjectName)
            if (subjectElm && subjectElm.offsetHeight > 0) {
                this.$emit('scrollSubject', subject.subjectName)
            } else {
                this.$emit('scrollSubject', subject.categoryName)
            }
        }
    }
}
</script>
<style>
.table-document-list table td .content img {
    width: 100%;
    height: 150px;
}
.table-document-list table .note {
    margin-top: 10px;
    padding-left: 5px;
    margin-bottom: 10px;
}
.table-document-list table tr td a {
    color: #3a8ee6 !important;
}
.table-document-list table {
    width: 100%;
    margin: 1em auto;
    /*border: 2px solid #d6d6d6;*/
}
.table-document-list .table td {
    padding: 1em;
    /*background: #e6f6fe;*/
    font-size: 14px;
    vertical-align: middle;
}
 .text-left{
    text-align: left !important;
}
.table-document-list .table .bg-blue td {
    background: #8edbff;
}
.table-document-list .table .bg-lightblue td {
    background: #e6f6fe;
}
.table-document-list .table th {
    text-align: center;
    background-color: #f7f0df ;
    padding: 1em;
    font-size: 16px;
    font-weight: bold;
    color: #321007;
}
.table-document-list .table th {
    vertical-align: middle;
}
.table-document-list tbody tr:hover>td {
    background-color: #F5F7FA;
}

.table-document-list tbody tr.waiting:hover>td {
    background-color: #ffbeff;
}

</style>
<style scoped>
@import "../../../../assets/css/custom.css";
.table {
    border-radius: unset !important;
}
.table thead th {
    border-bottom: 5px solid #ff9900;
}
.table thead th + th{
    border-left: 1px solid #d6d6d6 !important;
}
.table th {
    background-color: #fffaf0 !important;
}
.table tr {
    background-color: #fffafa;
}
.table tbody td + td {
    border-left: 1px solid #d6d6d6 !important;
}
.table td {
    border-top: 1px solid #d6d6d6 !important;
}
@media screen and (min-width:768px) {
    .has-border-right {
        border-right: 1px solid #d6d6d6 !important;
    }

}
@media only screen and (max-width: 600px) {
    p {
        font-size: 14px;
    }
}
.memo-text {
    white-space: pre-wrap;
}
.subject-name {
    margin-left: 8%;
}
.button-show-hide {
    border: none !important;
    background: none !important;
    color: blue !important;
}
</style>
